import React, { ChangeEvent } from "react";
import './FormInput.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';

interface FormInputProps {
  form: Record<string, any>;
  onTextChange: (e: ChangeEvent<HTMLInputElement>) => void;
  label: string;
  name: string;
  placeholder: string;
  type?: string;
  max?: string;
  required?: boolean;
  disabled?: boolean;
  errors?: Record<string, any>;
  pattern?: string;
  title?: string;
}

const FormInput = ({
  form,
  onTextChange,
  label,
  name,
  placeholder,
  title,
  required,
  disabled,
  errors,
  type = 'text',
  max,
  pattern
}: FormInputProps) => {
  const [showPassword, setShowPassword] = React.useState(false);
  const isPassword = type === 'password';

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const getInputType = () => {
    if (isPassword) {
      return showPassword ? 'text' : 'password';
    }
    return type;
  };

  return (
    <div className="form-input">
      <label htmlFor={name} className="form-label">
        {label} {required && (<span className="required">*</span>)}
      </label>
      <div className="input-container">
        <input
          id={name}
          disabled={disabled}
          name={name}
          type={getInputType()}
          max={max}
          value={form[name] || ''}
          onChange={(e) => onTextChange(e)}
          placeholder={`${placeholder}`}
          pattern={pattern}
          title={title}
          className={isPassword ? 'has-password-toggle' : ''}
        />
        {isPassword && (
          <button
            type="button"
            className="password-toggle"
            onClick={togglePasswordVisibility}
            aria-label={showPassword ? "Hide password" : "Show password"}
          >
            <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
          </button>
        )}
      </div>
      {errors && errors[name] && <p className="error">{errors[name]}</p>}
    </div>
  );
}

export default FormInput;